import React from 'react';

import * as S from './styles';

export const Slide1: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.Title>Impacto surreal</S.Title>
        <S.Text>
          Viaje com Thai de Melo pelos delírios coloridos e geométricos da
          beleza desta temporada.
        </S.Text>
        <S.Credit>
          <span>Fotos:</span> Juliana Rocha
          <br />
          <span>Edição de beleza:</span> Pedro Camargo
        </S.Credit>
      </S.Content>
      <S.Legend>
        Beleza: Helder Rodrigues. Styling: Lucas Boccalão. Brincos, Laura
        Cangassu.
      </S.Legend>
    </S.Container>
  );
};
